/**
 * Wein-PDP: Nährwert-Link einblenden, wenn ?view=naehrwerte-data Inhalte liefert.
 */
(function () {
  const pending = document.querySelector('[data-nutrition-pending]');
  if (!pending) return;

  const handle = pending.closest('[data-product-handle]')?.dataset.productHandle?.trim();
  if (!handle) return;

  const url = new URL(`/products/${encodeURIComponent(handle)}`, window.location.origin);
  url.searchParams.set('view', 'naehrwerte-data');
  url.searchParams.set('_', String(Date.now()));

  fetch(url.toString())
    .then((response) => (response.ok ? response.text() : ''))
    .then((html) => {
      if (typeof html !== 'string' || html.length === 0) return;
      if (!html.includes('wine-nutrition-table')) return;
      if (html.includes('wine-nutrition-page__empty')) return;
      pending.hidden = false;
    })
    .catch(() => {});
})();
